import { MaterialFabricEnum } from "../../enum"

export class FabricRequestCodeDto {
    buyerId : number
    fabricTypeId: number
    weaveId: number
    weight: number
    weightUnit: number
    epiConstruction: string
    ppiConstruction: string
    yarnType: string
    width: number
    widthUnit: number
    finishId: number
    contentId: number
    shrinkage: string
    m3Code: string
    hsnCode: string
    status: MaterialFabricEnum
    isActive?: boolean
    createdUser?: string
    updatedUser?: string
    versionFlag?: number
    fabricRequestCodeId?: number
    contentsData?:ContentsData
    remarks?:string
    fabricYarnInfo?: any[]; orderType?: string;
    minMoqQuantity?: number;
    maxMoqQuantity?: number;
    tolerance?: number;
    shadeNo?:number;
    moqUom?:number;
    plantId?:number;
    buyerEmail?:string;
    createdAt?:Date
    marketingMail?:string
    marketingUser?:string
    

    constructor(
        buyerId:number,
        fabricTypeId: number,
        weaveId: number,
        weight: number,
        weightUnit: number,
        epiConstruction: string,
        ppiConstruction: string,
        yarnType: string,
        width: number,
        widthUnit: number,
        finishId: number,
        contentId: number,
        shrinkage: string,
        m3Code: string,
        hsnCode: string,
        status?: MaterialFabricEnum,
        isActive?: boolean,
        createdUser?: string,
        updatedUser?: string,
        versionFlag?: number,
        fabricRequestCodeId?: number,
        contentsData?:ContentsData,
        remarks?:string,fabricYarnInfo?: any[], orderType?: string,
        minMoqQuantity?: number,
        maxMoqQuantity?: number,
        tolerance?: number,
        shadeNo?:number,
        moqUom?:number,
        plantId?:number,
        buyerEmail?:string,
        createdAt?:Date,
        marketingMail?:string,
        marketingUser?:string
        
    ){
        this.buyerId = buyerId
        this.fabricRequestCodeId = fabricRequestCodeId
        this.fabricTypeId = fabricTypeId
        this.weaveId = weaveId
        this.weight = weight
        this.weightUnit = weightUnit
        this.epiConstruction = epiConstruction
        this.ppiConstruction = ppiConstruction
        this.yarnType = yarnType
        this.width = width
        this.widthUnit = widthUnit
        this.finishId = finishId
        this.contentId = contentId
        this.shrinkage = shrinkage
        this.m3Code = m3Code
        this.hsnCode = hsnCode
        this.status = status
        this.isActive = isActive
        this.createdUser = createdUser
        this.updatedUser = updatedUser
        this.versionFlag = versionFlag
        this.contentsData=contentsData
        this.remarks=remarks
        this.fabricYarnInfo=fabricYarnInfo
        this.orderType=orderType
        this.minMoqQuantity=minMoqQuantity
        this.maxMoqQuantity=maxMoqQuantity
        this.tolerance=tolerance
        this.shadeNo=shadeNo
        this.moqUom=moqUom
        this.plantId=plantId
        this.buyerEmail=buyerEmail
        this.createdAt=createdAt
        this.marketingMail=marketingMail
        this.marketingUser=marketingUser

    }
}

export class ContentsData{
    content:number
    extraPer:number
    constructor(
        content:number,
        extraPer:number
    ){
        this.content=content
        this.extraPer=extraPer
    }

}

